import { axiosInstance } from "@/plugins/axios";
import { AxiosResponse } from "axios";
import { LoginFormModel } from "@/context/security/model/LoginFormModel";
import { UserModel } from "@/context/security/model/UserModel";

class AuthService {
  async login(cmd: LoginFormModel): Promise<UserModel> {
    try {
      this.setToken(this.createToken(cmd.username, cmd.password));
      const tokenResponse: AxiosResponse = await axiosInstance.post("security/login");
      const token = tokenResponse.data;
      const whoAmI = await this.whoAmI();
      return whoAmI;
    } catch (e) {
      throw e;
    }
  }

  logout(): void {
    this.removeToken();
  }

  async whoAmI(): Promise<UserModel> {
    const whoAmI: AxiosResponse = await axiosInstance.get("security/whoami");
    return whoAmI.data;
  }

  register(username: string, password: string) {}

  createToken(username: string, password: string) {
    return window.btoa(username + ":" + password);
  }

  setToken(token: string): void {
    localStorage.setItem("telemetric-data-server-frontend-token", token);
  }

  removeToken(): void {
    localStorage.removeItem("telemetric-data-server-frontend-token");
  }
}

export const authService = new AuthService();
